declare const require: (path: string) => string;

export const penthouses = [
  {id: 'МПр-517-1-01-50-01',
  tower: 'SOLO',
  floor: '50',
  flatNumber: '1',
  pentNumber: '517',
  area: '155.1',
  views: ['МГУ','Москва Сити'],
  priceForMeter: '430 000',
  priceFull: '66 693 000',
  active: true,
  detailed: {
      title: 'Пентхаус 517',
      name: 'SOLO',
      floor: '50',
      area: [
        {name: 'Общая площадь', value: '155.1'},
        {name: 'Терраса', value: '36.76'},
        {name: 'I Уровень', value: '76.7'},
        {name: 'II Уровень', value: '67.4'}
      ],
      priceFull: '66 693 000',
      views: ['МГУ','Москва Сити'],
      firstFloorImage: require('~/content/penthousesSchemes/SOLO-517-1.png'),
      secondFloorImage: require('./penthousesSchemes/SOLO-517-2.png'),
      locationImageFirst: require('./penthousesLocation/solo-517.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-solo-517.pdf')
    }
  },
  {id: 'МПр-521-1-01-50-05',
  tower: 'SOLO',
  floor: '50',
  flatNumber: '5',
  pentNumber: '521',
  area: '176.6',
  views: ['МГУ','Парк 50-ти летия Октября'],
  priceForMeter: '451 500',
  priceFull: '79 734 900',
  active: true,
  detailed: {
      title: 'Пентхаус 521',
      name: 'SOLO',
      floor: '50',
      area: [
        {name: 'Общая площадь', value: '176.6'},
        {name: 'Терраса', value: '38.04'},
        {name: 'I Уровень', value: '96.7'},
        {name: 'II Уровень', value: '68.2'}
      ],
      priceFull: '79 734 900',
      views: ['МГУ','Парк 50-ти летия Октября'],
      firstFloorImage: require('./penthousesSchemes/SOLO-521-1.png'),
      secondFloorImage: require('./penthousesSchemes/SOLO-521-2.png'),
      locationImageFirst: require('./penthousesLocation/solo-521.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-solo-521.pdf')
    }
  },
  {id: 'МПр-522-1-01-50-06',
  tower: 'SOLO',
  floor: '50',
  flatNumber: '6',
  pentNumber: '522',
  area: '203.4',
  views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
  priceForMeter: '430 500',
  priceFull: '87 563 700',
  active: true,
  detailed: {
      title: 'Пентхаус 522',
      name: 'SOLO',
      floor: '50',
      area: [
        {name: 'Общая площадь', value: '203.4'},
        {name: 'Терраса', value: '36.73'},
        {name: 'I Уровень', value: '124.5'},
        {name: 'II Уровень', value: '67.9'}
      ],
      priceFull: '87 563 700',
      views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
      firstFloorImage: require('./penthousesSchemes/SOLO-522-1.png'),
      secondFloorImage: require('./penthousesSchemes/SOLO-522-2.png'),
      locationImageFirst: require('./penthousesLocation/solo-522.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-solo-522.pdf')
    }
  },
  {id: 'МПр-526-1-01-50-10',
  tower: 'SOLO',
  floor: '50',
  flatNumber: '10',
  pentNumber: '526',
  area: '185.5',
  views: ['Долина реки Раменки','Москва Сити'],
  priceForMeter: '430 000',
  priceFull: '79 765 000',
  active: true,
  detailed: {
      title: 'Пентхаус 526',
      name: 'SOLO',
      floor: '50',
      area: [
        {name: 'Общая площадь', value: '185.5'},
        {name: 'Терраса', value: '37.39'},
        {name: 'I Уровень', value: '102.5'},
        {name: 'II Уровень', value: '71.8'}
      ],
      priceFull: '79 765 000',
      views: ['Долина реки Раменки','Москва Сити'],
      firstFloorImage: require('./penthousesSchemes/SOLO-526-1.png'),
      secondFloorImage: require('./penthousesSchemes/SOLO-526-2.png'),
      locationImageFirst: require('./penthousesLocation/solo-526.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-solo-526.pdf')
    }
  },
  {id: 'МПр-337-1-02-51-02',
  tower: 'FAMILY',
  floor: '51',
  flatNumber: '2',
  pentNumber: '337',
  area: '194.2',
  views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
  priceForMeter: '451 500',
  priceFull: '87 681 300',
  active: true,
  detailed: {
      title: 'Пентхаус 337',
      name: 'FAMILY',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '194.2'},
        {name: 'Терраса', value: '42.59'},
        {name: 'I Уровень', value: '107.9'},
        {name: 'II Уровень', value: '73.8'}
      ],
      priceFull: '87 681 300',
      views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
      firstFloorImage: require('./penthousesSchemes/FAMILY-337-1.png'),
      secondFloorImage: require('./penthousesSchemes/FAMILY-337-2.png'),
      locationImageFirst: require('./penthousesLocation/family-337.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-family-337.pdf')
    }
  },
  {id: 'МПр-338-1-02-51-03',
    tower: 'FAMILY',
    floor: '51',
    flatNumber: '3',
    pentNumber: '338',
    area: '220',
    views: ['Долина реки Раменки', 'Москва Сити'],
    priceForMeter: '410 000',
    priceFull: '90 200 000',
    active: true,
    detailed: {
      title: 'Пентхаус 338',
      name: 'FAMILY',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '220'},
        {name: 'Терраса', value: '40,91'},
        {name: 'I Уровень', value: '133,2'},
        {name: 'II Уровень', value: '74,5'}
      ],
      priceFull: '90 200 000',
      views: ['Долина реки Раменки', 'Москва Сити'],
      firstFloorImage: require('./penthousesSchemes/FAMILY-338-1.png'),
      secondFloorImage: require('./penthousesSchemes/FAMILY-338-2.png'),
      locationImageFirst: require('./penthousesLocation/family-338.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-family-338.pdf')
    }
  },
  {id: 'МПр-340-1-02-51-05',
    tower: 'FAMILY',
    floor: '51',
    flatNumber: '5',
    pentNumber: '340',
    area: '220.6',
    views: ['МГУ', 'Москва Сити'],
    priceForMeter: '410 000',
    priceFull: '90 446 000',
    active: true,
    detailed: {
      title: 'Пентхаус 340',
      name: 'FAMILY',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '220,6'},
        {name: 'Терраса', value: '40,86'},
        {name: 'I Уровень', value: '135,9'},
        {name: 'II Уровень', value: '72,4'}
      ],
      priceFull: '90 446 000',
      views: ['МГУ', 'Москва Сити'],
      firstFloorImage: require('./penthousesSchemes/FAMILY-340-1.png'),
      secondFloorImage: require('./penthousesSchemes/FAMILY-340-2.png'),
      locationImageFirst: require('./penthousesLocation/family-340.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-family-340.pdf')
    }
  },
  {id: 'МПр-341-1-02-51-06',
    tower: 'FAMILY',
    floor: '51',
    flatNumber: '6',
    pentNumber: '341',
    area: '193.6',
    views: ['Парк 50-ти летия Октября','МГУ'],
    priceForMeter: '451 500',
    priceFull: '87 410 400',
    active: true,
    detailed: {
      title: 'Пентхаус 341',
      name: 'FAMILY',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '193,6'},
        {name: 'Терраса', value: '41,13'},
        {name: 'I Уровень', value: '107,8'},
        {name: 'II Уровень', value: '73,5'}
      ],
      priceFull: '87 410 400',
      views: ['Парк 50-ти летия Октября','МГУ'],
      firstFloorImage: require('./penthousesSchemes/FAMILY-341-1.png'),
      secondFloorImage: require('./penthousesSchemes/FAMILY-341-2.png'),
      locationImageFirst: require('./penthousesLocation/family-341.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-family-341.pdf')
    }
  },
  {id: 'МПр-431-1-03-51-02',
    tower: 'TANDEM',
    floor: '51',
    flatNumber: '2',
    pentNumber: '431',
    area: '194.8',
    views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
    priceForMeter: '420 000',
    priceFull: '81 816 000',
    active: true,
    detailed: {
      title: 'Пентхаус 431',
      name: 'TANDEM',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '194,8'},
        {name: 'Терраса', value: '43'},
        {name: 'I Уровень', value: '108,8'},
        {name: 'II Уровень', value: '73,1'}
      ],
      priceFull: '81 816 000',
      views: ['Долина реки Раменки','Парк 50-ти летия Октября'],
      firstFloorImage: require('./penthousesSchemes/TANDEM-431-1.png'),
      secondFloorImage: require('./penthousesSchemes/TANDEM-431-2.png'),
      locationImageFirst: require('./penthousesLocation/tandem-431.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-tandem-431.pdf')
    }
  },
  {id: 'МПр-432-1-03-51-03',
    tower: 'TANDEM',
    floor: '51',
    flatNumber: '3',
    pentNumber: '432',
    area: '242.5',
    views: ['Долина реки Раменки','Москва Сити'],
    priceForMeter: '410 000',
    priceFull: '99 425 000',
    active: true,
    detailed: {
      title: 'Пентхаус 432',
      name: 'TANDEM',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '242,5'},
        {name: 'Терраса', value: '42'},
        {name: 'I Уровень', value: '160,1'},
        {name: 'II Уровень', value: '69,8'}
      ],
      priceFull: '99 425 000',
      views: ['Долина реки Раменки','Москва Сити'],
      firstFloorImage: require('./penthousesSchemes/TANDEM-432-1.png'),
      secondFloorImage: require('./penthousesSchemes/TANDEM-432-2.png'),
      locationImageFirst: require('./penthousesLocation/tandem-432.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-tandem-432.pdf')
    }
  },
  {id: 'МПр-433-1-03-51-04',
    tower: 'TANDEM',
    floor: '51',
    flatNumber: '4',
    pentNumber: '433',
    area: '244.4',
    views: ['МГУ','Москва Сити'],
    priceForMeter: '500 000',
    priceFull: '122 200 000',
    active: true,
    detailed: {
      title: 'Пентхаус 433',
      name: 'TANDEM',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '244,4'},
        {name: 'Терраса', value: '42,3'},
        {name: 'I Уровень', value: '160,5'},
        {name: 'II Уровень', value: '71,2'}
      ],
      priceFull: '99 425 000',
      views: ['МГУ','Москва Сити'],
      firstFloorImage: require('./penthousesSchemes/TANDEM-433-1.png'),
      secondFloorImage: require('./penthousesSchemes/TANDEM-433-2.png'),
      locationImageFirst: require('./penthousesLocation/tandem-433.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-tandem-433.pdf')
    }
  },
  {id: 'МПр-434-1-03-51-05',
    tower: 'TANDEM',
    floor: '51',
    flatNumber: '5',
    pentNumber: '434',
    area: '213.8',
    views: ['МГУ','Парк 50-ти летия Октября'],
    priceForMeter: '500 000',
    priceFull: '106 900 000',
    active: true,
    detailed: {
      title: 'Пентхаус 434',
      name: 'TANDEM',
      floor: '51',
      area: [
        {name: 'Общая площадь', value: '213,8'},
        {name: 'Терраса', value: '43,3'},
        {name: 'I Уровень', value: '129,3'},
        {name: 'II Уровень', value: '71,5'}
      ],
      priceFull: '99 425 000',
      views: ['МГУ','Парк 50-ти летия Октября'],
      firstFloorImage: require('./penthousesSchemes/TANDEM-434-1.png'),
      secondFloorImage: require('./penthousesSchemes/TANDEM-434-2.png'),
      locationImageFirst: require('./penthousesLocation/tandem-434.png'),
      locationImageSecond: '',
      linkToPDF: require('./plans/nebo-tandem-434.pdf')
    }
  }
]